(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breezy-dyson-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('breezy-dyson-tour')) {
  customElements.define('breezy-dyson-tour', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const buttons = Array.from(this.querySelectorAll('[data-feature]'));
      const panels = Array.from(this.querySelectorAll('[data-feature-panel]'));
      const panelWrap = this.querySelector('.bdy__feature-panel');
      const closeButton = this.querySelector('.bdy__feature-close');
      if (!buttons.length || buttons.length !== panels.length) return;
      const activate = (id, animate) => {
        panelWrap.hidden = false;
        buttons.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.feature === id)));
        panels.forEach(panel => {
          const selected = panel.dataset.featurePanel === id;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected && animate);
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => activate(button.dataset.feature, true)));
      closeButton.addEventListener('click', () => {
        const selectedButton = buttons.find(button => button.getAttribute('aria-expanded') === 'true');
        panelWrap.hidden = true;
        buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
        if (selectedButton) selectedButton.focus();
      });
      this.addEventListener('keydown', event => { if (event.key === 'Escape' && !panelWrap.hidden) closeButton.click(); });
      activate(buttons[0].dataset.feature, false);
      this.dataset.ready = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breezy-generic-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('breezy-generic-details')) {
    class BreezyGenericDetails extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.enhanceDescription();
        this.initGallery();
        this.initStoryMotion();
        const reviewLink = this.querySelector('[data-bgp-review-link]');
        const reviewTarget = document.getElementById('judgeme_product_reviews');
        if (reviewLink && reviewTarget) reviewLink.hidden = false;
        else if (reviewLink) window.addEventListener('load', () => {
          if (document.getElementById('judgeme_product_reviews')) reviewLink.hidden = false;
        }, { once: true });
      }
      enhanceDescription() {
        if (this.dataset.enhanced) return;
        const source = this.querySelector('[data-bgp-source]');
        if (!source || !source.textContent.trim()) return;
        const keys = {
          features: ['key features','features','product features','features and benefits','highlights','product highlights'],
          specs: ['specifications','specification','technical specifications','technical details','product specifications','dimensions','dimensions and specifications'],
          included: ['whats included','what is included','included accessories','included items','package contents','package includes','in the box','whats in the box','what is in the box'],
          care: ['care','use and care','care and use','care instructions','care and maintenance','use instructions','usage and care','how to use','product care']
        };
        const normalize = value => value.toLowerCase().replace(/[’'":]/g,'').replace(/&/g,'and').replace(/\s+/g,' ').trim();
        const content = {intro: [], features: [], specs: [], included: [], care: [], more: []};
        let current = 'intro';
        let recognized = 0;
        const visit = node => {
          if (node.nodeType === 1 && ['DIV','SECTION','ARTICLE'].includes(node.tagName) && !node.matches('[role], [id]')) {
            Array.from(node.childNodes).forEach(visit);
            return;
          }
          if (node.nodeType === 1) {
            const label = normalize(node.textContent);
            const heading = /^H[1-6]$/.test(node.tagName);
            const boldParagraph = node.tagName === 'P' && node.querySelector('strong,b') && normalize(Array.from(node.querySelectorAll('strong,b')).map(el=>el.textContent).join(' ')) === label;
            const bareBold = ['STRONG','B'].includes(node.tagName);
            if ((heading || boldParagraph || bareBold) && label.length < 90) {
              const match = Object.entries(keys).find(([,aliases])=>aliases.includes(label));
              if (match) { current = match[0]; recognized++; return; }
              if (heading) current = 'more';
            }
          }
          content[current].push(node.cloneNode(true));
        };
        Array.from(source.childNodes).forEach(visit);
        if (!recognized) return;
        const hasContent = nodes => nodes.some(node => node.textContent.trim() || (node.nodeType === 1 && (node.matches('img,video,iframe') || node.querySelector('img,video,iframe'))));
        const introduction = this.querySelector('[data-bgp-introduction]');
        if (hasContent(content.intro)) { introduction.replaceChildren(...content.intro); introduction.hidden = false; }
        for (const key of ['features','specs','included','care','more']) {
          const target = this.querySelector(`[data-bgp-content="${key}"]`);
          const parent = this.querySelector(`[data-bgp-section="${key}"]`) || this.querySelector(`[data-bgp-${key}]`);
          if (hasContent(content[key]) && target && parent) {
            target.replaceChildren(...content[key]);
            parent.hidden = false;
            const jumpLink = this.querySelector(`[data-bgp-${key}-link]`);
            if (jumpLink) jumpLink.hidden = false;
          }
        }
        const original = this.querySelector('[data-bgp-original]');
        this.querySelector('[data-bgp-original-slot]').append(source);
        original.hidden = false;
        this.querySelectorAll('[data-bgp-introduction] [id], [data-bgp-content] [id]').forEach(el => el.removeAttribute('id'));
        const features = this.querySelector('[data-bgp-section="features"]');
        if (!features.hidden) {
          const jump = this.querySelector('[data-bgp-jump]');
          jump.hidden = this.classList.contains('bgp--compact');
          const secondPhoto = this.querySelector('[data-bgp-photo="1"]');
          if (secondPhoto && this.querySelector('[data-bgp-feature-image]')) secondPhoto.remove();
        }
        this.dataset.enhanced = 'true';
      }
      initStoryMotion() {
        const photo = this.querySelector('.bgp__intro-image img');
        if (!photo || !('IntersectionObserver' in window) || typeof photo.animate !== 'function' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.storyObserver = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          this.storyObserver.disconnect();
          if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
            photo.animate([{ transform: 'scale(1.035)' }, { transform: 'scale(1)' }], {
              duration: 620, easing: 'cubic-bezier(.16,1,.3,1)'
            });
          }
        }, { threshold: .45 });
        this.storyObserver.observe(photo);
      }
      initGallery() {
        const gallery = this.querySelector('[data-bgp-gallery]');
        if (!gallery) return;
        const track = gallery.querySelector('[data-bgp-track]');
        if (!track.children.length) { gallery.hidden = true; return; }
        const previous = gallery.querySelector('[data-bgp-prev]');
        const next = gallery.querySelector('[data-bgp-next]');
        const controls = gallery.querySelector('[data-bgp-controls]');
        const update = () => {
          const max = track.scrollWidth-track.clientWidth;
          controls.hidden = max < 3;
          previous.disabled = track.scrollLeft < 3;
          next.disabled = track.scrollLeft > max-3;
        };
        const move = direction => {
          const first = track.firstElementChild;
          const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap)||0);
          track.scrollBy({left:step*direction,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        };
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        previous.addEventListener('click',()=>move(-1),options);
        next.addEventListener('click',()=>move(1),options);
        track.addEventListener('scroll',update,{...options,passive:true});
        track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}},options);
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.storyObserver?.disconnect();
        delete this.dataset.ready;
      }
    }
    customElements.define('breezy-generic-details',BreezyGenericDetails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breezy-graphite"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('graphite-hero')) {
  customElements.define('graphite-hero', class extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('graphite__hero--viewport')) return;
      const header = document.querySelector('.bt-site-header');
      const announcement = this.parentElement.querySelector('.graphite__announcement');
      const bars = [header, announcement].filter(Boolean);
      const update = () => this.style.setProperty('--graphite-opening-bars',
        bars.reduce((height, bar) => height + bar.getBoundingClientRect().height, 0) + 'px');
      this.observer = new ResizeObserver(update);
      for (const bar of bars) this.observer.observe(bar);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
if (!customElements.get('graphite-rail')) {
  customElements.define('graphite-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const rails = [...this.querySelectorAll('.graphite__rail')];
      const arrows = [...this.querySelectorAll('[data-graphite-scroll]')];
      const tabs = this.querySelector('.graphite__tabs');
      const updateLens = () => {
        const selected = tabs?.querySelector('[aria-pressed="true"]');
        if (!selected || !tabs.closest('.graphite--glass') || !selected.offsetWidth) return;
        tabs.style.setProperty('--graphite-lens-x', selected.offsetLeft + 'px');
        tabs.style.setProperty('--graphite-lens-width', selected.offsetWidth + 'px');
        tabs.setAttribute('data-lens-ready', '');
      };
      const activeRail = () => this.querySelector('[data-graphite-panel]:not([hidden]) .graphite__rail');
      const updateArrows = () => {
        const rail = activeRail();
        if (!rail) return;
        const offset = Math.abs(rail.scrollLeft);
        arrows[0].disabled = offset < 2;
        arrows[1].disabled = offset + rail.clientWidth >= rail.scrollWidth - 2;
      };
      for (const rail of rails) rail.addEventListener('scroll', updateArrows, { passive: true });
      const observer = new ResizeObserver(() => { updateArrows(); updateLens(); });
      observer.observe(this);
      if (tabs) {
        observer.observe(tabs);
        for (const button of tabs.querySelectorAll('button')) observer.observe(button);
      }
      updateArrows();
      updateLens();
      this.observer = observer;
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-graphite-tab]');
        if (tab) {
          for (const button of this.querySelectorAll('[data-graphite-tab]')) {
            button.setAttribute('aria-pressed', String(button === tab));
          }
          for (const panel of this.querySelectorAll('[data-graphite-panel]')) {
            panel.hidden = panel.dataset.graphitePanel !== tab.dataset.graphiteTab;
          }
          tabs.setAttribute('data-lens-animated', '');
          updateLens();
          updateArrows();
        }
        const arrow = event.target.closest('[data-graphite-scroll]');
        if (arrow) {
          const rail = activeRail();
          const firstCard = rail?.querySelector('.graphite__card');
          if (!firstCard) return;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const step = firstCard.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap);
          const direction = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
          rail.scrollBy({ left: direction * Number(arrow.dataset.graphiteScroll) * step, behavior: reduced ? 'instant' : 'smooth' });
        }
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breezy-promo-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('breezy-promo-popup')) {
    customElements.define('breezy-promo-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.editor = this.dataset.editor === 'true';
        this.cookieName = 'breezy_promo_seen';
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.previousFocus && this.previousFocus.isConnected && typeof this.previousFocus.focus === 'function') {
            this.previousFocus.focus({ preventScroll: true });
          }
        }, options);
        this.querySelector('[data-copy]').addEventListener('click', () => this.copyCode(), options);
        window.addEventListener('pagehide', () => {
          clearTimeout(this.timer);
          if (this.dialog.open) this.dialog.close();
        }, options);
        window.addEventListener('pageshow', event => {
          if (event.persisted) this.schedule();
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (this.editor && event.target && event.target.contains(this)) this.show(true);
        }, options);
        if (!this.editor) this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.dialog && this.dialog.open) this.dialog.close();
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
      excluded() {
        return //(cart|checkout|checkouts)(/|$)/i.test(window.location.pathname);
      }
      seen() {
        try { return document.cookie.split(';').some(value => value.trim() === this.cookieName + '=1'); }
        catch (error) { return true; }
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.excluded() || this.seen()) return;
        this.timer = setTimeout(() => this.show(false), 2400);
      }
      show(fromEditor) {
        if (!this.isConnected || this.dialog.open || this.excluded() || (!this.editor && this.seen())) return;
        if (!this.editor && (document.hidden || document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]'))) {
          this.timer = setTimeout(() => this.show(false), 900);
          return;
        }
        if (!this.editor) {
          try {
            document.cookie = this.cookieName + '=1; Path=/; Max-Age=2592000; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
            if (!this.seen()) return;
          } catch (error) { return; }
        }
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        const title = this.querySelector('[data-title]');
        if (title) title.focus({ preventScroll: true });
      }
      async copyCode() {
        const button = this.querySelector('[data-copy]');
        const label = this.querySelector('[data-copy-label]');
        const input = this.querySelector('input');
        const status = this.querySelector('[data-status]');
        const coupon = this.querySelector('[data-coupon]');
        const originalLabel = label.textContent;
        button.disabled = true;
        status.textContent = '';
        coupon.removeAttribute('data-copied');
        try {
              try { await navigator.clipboard.writeText(input.value); } catch (clipboardError) { input.focus(); input.select(); if (!document.execCommand('copy')) throw clipboardError; }
          status.textContent = status.dataset.success;
          label.textContent = 'Copied';
          coupon.setAttribute('data-copied', '');
        } catch (error) {
          input.focus();
          input.select();
          input.setSelectionRange(0, input.value.length);
          status.textContent = status.dataset.failure;
        } finally {
          button.disabled = false;
          if (this.dialog.open && document.activeElement !== input) button.focus({ preventScroll: true });
          if (label.textContent === 'Copied') setTimeout(() => { if (label.isConnected) label.textContent = originalLabel; }, 2200);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    function breezyPolicyNavigation(){document.querySelectorAll('.breezy-policy__navigation').forEach(function(nav){nav.open=!window.matchMedia('(max-width:749px)').matches;});}breezyPolicyNavigation();document.addEventListener('shopify:section:load',breezyPolicyNavigation);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-tabs"]) return;
  try {
    
if (!customElements.get('breezy-details-gallery')) {
  customElements.define('breezy-details-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryController) return;
      this.track = this.querySelector('.breezy-details__track');
      this.previous = this.querySelector('[data-gallery-previous]');
      this.next = this.querySelector('[data-gallery-next]');
      this.controls = this.querySelector('.breezy-details__controls');
      this.dots = this.querySelector('.breezy-details__dots');
      if (!this.track || !this.previous || !this.next) return;
      this.galleryController = new AbortController();
      const options = { signal: this.galleryController.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.galleryResizeObserver = new ResizeObserver(() => this.scheduleUpdate());
      this.galleryResizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.galleryController?.abort();
      this.galleryResizeObserver?.disconnect();
      cancelAnimationFrame(this.galleryFrame);
      this.galleryController = null;
    }
    scheduleUpdate() {
      cancelAnimationFrame(this.galleryFrame);
      this.galleryFrame = requestAnimationFrame(() => this.update());
    }
    update() {
      const overflow = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = overflow < 2;
      this.previous.disabled = position < 2;
      this.next.disabled = position >= overflow - 2;
      if (this.dots) {
        this.dots.hidden = overflow < 2;
        const photo = this.track.querySelector('.breezy-details__gallery-photo');
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const step = photo ? photo.getBoundingClientRect().width + gap : this.track.clientWidth;
        const current = Math.min(this.dots.children.length - 1, Math.round(position / step));
        Array.from(this.dots.children).forEach((dot, index) => dot.classList.toggle('is-current', index === current));
      }
    }
    move(direction) {
      const photo = this.track.querySelector('.breezy-details__gallery-photo');
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = photo ? photo.getBoundingClientRect().width + gap : this.track.clientWidth;
      const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: direction * distance * rtl, behavior });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
